class CartRecommendations extends HTMLElement {
    connectedCallback() {
        this.sectionId = this.dataset.sectionId;
        this.placeholder = this;

        document.body.addEventListener('cart:updated', (e) => {
            const items = e?.detail?.cart?.items || [];
            const pid = items.length ? String(items[items.length - 1].product_id) : null;
            this.load(pid);
        });

        this.load(this.dataset.productId);
    }

    load(productId) {
        if (!productId) return;

        fetch(
            `${Shopify.routes.root}recommendations/products` +
            `?section_id=${encodeURIComponent(this.sectionId)}` +
            `&product_id=${encodeURIComponent(productId)}` +
            `&limit=4`
        )
            .then(r => r.text())
            .then(html => {
                const tmp = document.createElement('div');
                tmp.innerHTML = html;
                const sectionHTML = tmp.querySelector(`[data-section-id="${this.sectionId}"]`);

                if (sectionHTML && sectionHTML.innerHTML.trim()) {
                    this.placeholder.innerHTML = sectionHTML.innerHTML;
                    this.classList.remove('hidden');
                    this.initSwiper();
                } else {
                    this.classList.add('hidden');
                }
            });
    }

    initSwiper() {
        const el = this.querySelector('swiper-container.cart-recommendations__swiper, swiper-container');
        if (!el) return;

        if (el.swiper) {
            try { el.swiper.update(); } catch (_) {}
            return;
        }

        const scope = this.closest('section') || this;
        const prev = scope.querySelector('.cart-recommendations__prev');
        const next = scope.querySelector('.cart-recommendations__next');

        const config = {
            spaceBetween: 12,
            slidesPerView: 4,
            breakpoints: {
                0:   { slidesPerView: 2.2, spaceBetween: 12 },
                990: { slidesPerView: 4,   spaceBetween: 16 },
            },
            watchOverflow: true,
            grabCursor: true,
        };
        if (prev && next) config.navigation = { prevEl: prev, nextEl: next };

        const run = () => {
            Object.assign(el, config);
            try { el.initialize(); } catch (_) {}
        };

        if (!customElements.get('swiper-container')) {
            customElements.whenDefined('swiper-container').then(run);
        } else {
            run();
        }
    }
}

customElements.define('cart-recommendations', CartRecommendations);